<template>
  <div class="container" @click="$emit('titleClicked')">
    <div class="document-card-wrapper">
      <div class="image-container">
        <img v-if="thumbUrl" :src="thumbUrl" alt="thumb" />
        <div v-else class="default-thumb" />
      </div>
      <div class="document-details">
        <h4 class="document-title" @click.stop="$emit('titleClicked')">
          {{ title }}
        </h4>
        <div>
          <span>{{ 'Page ' + page }}</span>
        </div>
      </div>
    </div>
    <div class="snippet-container">
      {{ snippet }}
    </div>
  </div>
</template>

<script>
export default {
  emits: ['titleClicked'],
  props: {
    title: {
      type: String,
      default: '',
    },
    page: {
      type: String,
      default: '',
    },
    snippet: {
      type: String,
      default: '',
    },
    thumbUrl: {
      type: String,
      default: '',
    },
  },
};
</script>

<style scoped lang="scss">
.container {
  background-color: $bb-neutral-0;
  width: 300px;
  max-height: 200px; /* Maximum height */
  overflow: hidden;
  border: 1px solid #ddd;
  border-radius: $bb-spacing-2;
  box-shadow: 2px 2px 10px rgba(0, 0, 0, 0.2);
  display: flex;
  flex-direction: column; /* Stack rows */
  z-index: 1000;

  .snippet-container {
    @include bb-medium-text-styles('xs');
    max-height: 130px; /* Subtract padding */
    overflow: hidden;
    color: $bb-neutral-1;
    padding-inline: $bb-spacing-3;
    display: -webkit-box;
    -webkit-line-clamp: 5; /* Number of lines before ellipsis */
    -webkit-box-orient: vertical;
    box-sizing: border-box;
    padding-top: 0;
    padding-bottom: 0; /* Prevents adding extra height */
    margin-bottom: $bb-spacing-3;
  }

  .document-card-wrapper {
    display: flex;
    flex-direction: row;
    gap: $bb-spacing-2;
    margin-bottom: $bb-spacing-3;
    background-color: $bb-neutral-5;
    padding: 12px 12px 4px 12px;

    .image-container {
      display: flex;
      flex-direction: column;
      justify-content: space-between; /* Aligns children (start, content, end) */
      border-radius: $bb-spacing-1;
      background-color: $bb-neutral-5;
      width: 64px;
      height: 50px;
      align-items: flex-start;
      gap: $bb-spacing-1;

      .default-thumb {
        align-self: flex-start;
        width: 60px;
        height: 48px;
        background-color: $bb-neutral-4;
      }

      img {
        max-width: 60px;
        max-height: 48px;
        align-self: center;
      }
    }

    .document-details {
      flex-grow: 1;
      display: flex;
      flex-direction: column;
      max-width: 100%;
      overflow: hidden;

      .document-title {
        @include bb-medium-text-styles('md');
        line-height: $bb-spacing-5;
        color: $bb-primary-3;
        cursor: pointer;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        max-width: 100%;
      }

      span {
        @include bb-medium-text-styles('xs');
        color: $bb-neutral-3;
        letter-spacing: 0.1px;
        font-size: 13px;
      }
    }
  }
}
</style>
